
import makeAgents from 'consts/agents'

export default {
  props: {
    type: {
      type: String,
      required: true
    },
    open: {
      type: Boolean,
      default: true
    },
    flat: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      all_agents: makeAgents()
    }
  },
  computed: {
    agent() {
      return this.all_agents.find(x => x.type === this.type)
    },
    color() {
      return this.agent.color
    },
    genrate(){
      return this.type === 'genrate'
    },
    icon() {
      if (this.genrate) return
      return this.agent.icon
    }
  }
}
